import { motion } from "framer-motion";
import { Star } from "@phosphor-icons/react";

const CARRIERS = [
  "Transamerica", "Nationwide", "Mutual of Omaha", "Pacific Life",
  "Foresters Financial", "Americo", "F&G", "North American",
];

export default function Carriers() {
  return (
    <section id="carriers" className="bg-warm-white py-20 lg:py-24 border-b border-black/[0.06]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <p className="eyebrow text-gold mb-4 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-gold" /> Carriers We Place Through
            </p>
            <h2 className="font-heading font-extrabold tracking-tighter text-navy text-[clamp(1.8rem,3.5vw,2.6rem)] leading-[1.05]">
              Tier-one, A-rated carriers — through World Financial Group.
            </h2>
          </div>
          <p className="text-brand-slate text-sm max-w-xs lg:text-right">
            As an independent producer we shop multiple carriers, so your recommendation is based
            on fit — never a single company's quota.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {CARRIERS.map((name, i) => (
            <motion.div
              key={name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              data-testid={`carrier-tile-${i}`}
              className="group relative flex flex-col items-center justify-center gap-2 rounded-xl border border-black/[0.08] bg-white px-4 py-8 transition-all hover:border-navy/30 hover:-translate-y-1"
            >
              <span className="absolute top-3 right-3 inline-flex items-center gap-0.5 text-[10px] font-semibold text-gold">
                <Star weight="fill" size={10} /> A+
              </span>
              <span className="font-heading font-extrabold text-navy text-lg sm:text-xl text-center tracking-tight">
                {name}
              </span>
            </motion.div>
          ))}
        </div>
        <p className="mt-6 text-[11px] text-light-slate">
          Carrier names are shown for identification only and do not imply endorsement. Availability varies by state and underwriting.
        </p>
      </div>
    </section>
  );
}
